// MENUS
export const REPORT_GET_MENUS = 'REPORT_GET_MENUS';
export const REPORT_GET_MENUS_SUCCESS = 'REPORT_GET_MENUS_SUCCESS';
export const REPORT_GET_MENUS_ERROR = 'REPORT_GET_MENUS_ERROR';

// DIVISIONS
export const REPORT_GET_DIVISIONS = 'REPORT_GET_DIVISIONS';
export const REPORT_GET_DIVISIONS_SUCCESS = 'REPORT_GET_DIVISIONS_SUCCESS';
export const REPORT_GET_DIVISIONS_ERROR = 'REPORT_GET_DIVISIONS_ERROR';
